"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTabOption = exports.StyledTabs = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const polished_1 = require("polished");
const variants_1 = require("../../themes/variants");
const button_1 = require("../button");
exports.StyledTabs = styled_components_1.default.div.withConfig({
    shouldForwardProp: (prop) => !["disabled", "onChange", "variant"].includes(prop),
}) `
  display: flex;
  flex-wrap: wrap;
  padding: 0.125rem;
  line-height: 1;
  flex-wrap: nowrap;
  overflow-x: auto;
  position: relative;
  overflow-y: hidden;
  ${({ theme }) => {
    return (0, styled_components_1.css) `
      background-color: ${(0, variants_1.variantBgColor)({ theme })};
    `;
}}
`;
exports.StyledTabOption = (0, styled_components_1.default)(button_1.Button).withConfig({
    shouldForwardProp: (prop) => !["value", "active"].includes(prop),
}) `
  flex: 1;
  max-width: 20rem;
  min-width: 3rem;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  &,
  & > label {
    line-height: 1.5;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  & > label {
    margin-top: 0.27rem;
  }
  &[data-testid="tab-add"] {
    flex: none;
    padding: 0;
    margin: 0.5rem;
    position: sticky;
    right: 0;
    &:before {
      content: " ";
      background-color: white;
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 0;
    }
    & > i {
      z-index: 1;
      line-height: 1.5;
    }
  }
  [data-testid="close-icon"] {
    transition: color 0.3s;
    font-size: 1.5rem;
    margin-left: 0.5rem;
  }
  &[data-testid="tab-option"] {
    ${({ active, disabled, theme, variant }) => {
    const variantColor = (0, variants_1.variantTextColor)({ theme, variant });
    const defaultColor = (0, variants_1.variantTextColor)({ theme });
    const disabledColor = (0, variants_1.variantTextColor)({ theme, variant: "disabled" });
    const textColor = disabled ? disabledColor : defaultColor;
    return (0, styled_components_1.css) `
        color: ${textColor};
        border-radius: unset;
        padding: 0.5rem 0.5rrem 0.2rem 0.5rem;
        border-bottom-width: 0.3rem;
        border-bottom-style: solid;
        border-bottom-color: transparent;
        &:not(:last-child) {
          padding-right: 0.4rem;
          border-right: 0.1rem solid ${(0, polished_1.lighten)(0.1, disabledColor)};
        }
        ${!disabled &&
        `
      [data-testid="close-icon"] {
        color: ${defaultColor};
      } 
      ${active
            ? `
        min-width: 10rem;
        color:${variantColor};
        border-bottom-color: ${variantColor};
        `
            : ""};
      &:hover {
        color:${variantColor};
        ${`border-bottom-color: ${variantColor}`};
        [data-testid="close-icon"] {
          color: ${defaultColor};
        }
      }`}
      `;
}}
  }
`;
//# sourceMappingURL=styled.js.map